import { render } from "./SnippetIntroText.vue?vue&type=template&id=51c13e62"
import script from "./SnippetIntroText.vue?vue&type=script&lang=js"
export * from "./SnippetIntroText.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__